import { Link, ListItem, ListItemText } from "@mui/material";
import MuiMarkdown from "mui-markdown";
import type { GrampsNote } from "../utils";
import { getGrampsBackendBase, isMarchandViveretHost } from "../grampsAuth";
import { getMathMarkdownOptions } from "./markdownMath";

function getBackendNoteUrl(noteId: string) {
    if (!noteId || isMarchandViveretHost()) return '';
    const backendBase = getGrampsBackendBase();
    return `${backendBase.replace(/\/+$/, '')}/note/${encodeURIComponent(noteId)}`;
}

export function NoteItem({ note }: { note: GrampsNote }) {
    const noteId = String(note["@id"] || '').trim();
    const backendNoteUrl = getBackendNoteUrl(noteId);

    return (
        <ListItem sx={{ px: 0 }}>
            <ListItemText
                primary={
                    <>
                        {backendNoteUrl && (
                            <Link
                                href={backendNoteUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ display: 'block', fontSize: '0.7em', mb: 0.25 }}
                            >
                                {noteId}
                            </Link>
                        )}
                        <MuiMarkdown options={getMathMarkdownOptions({
                            span: { props: { style: { fontSize: 'x-small' } } }
                        })}>
                            {note.text}
                        </MuiMarkdown>
                    </>
                }
            />
        </ListItem>
    );
}
